<div class="ig-modal event-tiers-modal">
  <div class="close-button"><mat-icon (click)="close()">clear</mat-icon></div>
  <div class="title">Event Subscription Tiers</div>
  <p>Changing a tier limit immediately updates reporting for every account assigned to that tier.</p>
  <ig-spinner *ngIf="loading"></ig-spinner>
  <table>
    <thead><tr><th>Name</th><th>Annual event limit</th><th>Active</th><th></th></tr></thead>
    <tbody>
      <tr *ngFor="let tier of tiers">
        <td><input [(ngModel)]="tier.name"></td>
        <td><input type="number" min="1" step="1" [(ngModel)]="tier.annualEventLimit"></td>
        <td><mat-checkbox [(ngModel)]="tier.isActive"></mat-checkbox></td>
        <td><button mat-raised-button color="primary" [disabled]="savingId === tier._id" (click)="save(tier)">Save</button></td>
      </tr>
      <tr class="new-tier">
        <td><input placeholder="New tier name" [(ngModel)]="newTier.name"></td>
        <td><input type="number" min="1" step="1" placeholder="Annual limit" [(ngModel)]="newTier.annualEventLimit"></td>
        <td><mat-checkbox [(ngModel)]="newTier.isActive"></mat-checkbox></td>
        <td><button mat-raised-button color="accent" [disabled]="savingId === 'new'" (click)="create()">Add tier</button></td>
      </tr>
    </tbody>
  </table>
</div>



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/event.subscription.tiers/event.subscription.tiers.modal.component.html